// extracted by mini-css-extract-plugin
export var columnList = "_9y-0";